'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEnhancedEncryption = function NotificationEnhancedEncryption(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z' })
  );
};
NotificationEnhancedEncryption = (0, _pure2.default)(NotificationEnhancedEncryption);
NotificationEnhancedEncryption.displayName = 'NotificationEnhancedEncryption';
NotificationEnhancedEncryption.muiName = 'SvgIcon';

exports.default = NotificationEnhancedEncryption;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/notification/enhanced-encryption.js
// module id = 1744
// module chunks = 0